import type { GetCommerceCartRequest, GetCommerceCartResponse } from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const getCommerceCartOperation = defineCommerceOperation<
    GetCommerceCartRequest,
    GetCommerceCartResponse
>("commerce.cart.get");
